<template functional>
  <div>
    <a
      v-if="props.rowValue > 0"
      href="#"
      @click="$options.show(props)"
      class="Azul"
      >{{ props.rowValue }}</a
    >
  </div>
</template>

<script>
export default {
  name: "HyperlinkForModuleAmonestacion",
  monthName: {
    1: { Name: "Enero" },
    2: { Name: "Febrero" },
    3: { Name: "Marzo" },
    4: { Name: "Abril" },
    5: { Name: "Mayo" },
    6: { Name: "Junio" },
    7: { Name: "Julio" },
    8: { Name: "Agosto" },
    9: { Name: "Septiembre" },
    10: { Name: "Octubre" },
    11: { Name: "Noviembre" },
    12: { Name: "Diciembre" }
  },
  show(ops) {
    ops;
    ops.row.OpenDetailAmonestacion(
      ops.row,
      ops.column,
      ops.row.year,
      ops.row.Type
    );
  }
};
</script>

<style scoped>
.Azul {
  width: 2rem;
  height: 2rem;
  color: blue;
  background-color: rgba(25, 133, 187, 0.1);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: auto;
  padding: 3%;
}
</style>
